import { gql } from "apollo-angular";

const UPDATE_CROSS_UPLOAD= gql`
query updateCrossUpload($crossUploadRequestId: Long!, $fromProductId: Long!){
  updateCrossUpload(
    updateCrossUploadRequests: [
      {
        crossUploadRequestId: $crossUploadRequestId,
        fromProductId: $fromProductId
      }
    ]
  ) {
    id
  }
}
`;

export default UPDATE_CROSS_UPLOAD;